import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import moment from 'moment';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import classNames from 'classnames';
import { Checkbox } from '@material-ui/core';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import IdentityUserKidApprovalConfirm from './IdentityUserKidApprovalConfirm';
import {
  getIdentities,
  editIdentityUserKidStatus
} from '../../actions/Identity';
import { sendLogin } from '../../auth/Auth';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 88,
    overflow: 'scroll',
    outline: 'none'
  },
  document: {
    width: '90%',
    margin: '5px'
  },
  itemDiv: {
    marginBottom: 16
  },
  titleHeader: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '140%'
  },
  textUserName: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: '140%',
    marginTop: 40
  },
  fs20: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: '140%'
  },
  fs16: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '100%'
  },
  fs18: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '140%'
  },
  mt40: {
    marginTop: 40
  },
  mb52: {
    marginBottom: 52
  },
  textRed: {
    color: '#F50057'
  },
  imageIdentity: {
    maxWidth: '100%',
    width: 'auto'
  },
  reasonComment: {
    width: '100%',
    height: '200px',
    maxWidth: '100%'
  },
  kidInfoContainer: {
    display: 'flex',
    marginBottom: 20
  },
  kidInfoDetails: {
    flexShrink: 0,
    width: 500,
    marginRight: 20
  },
  kidInfoImage: {
    flexGrow: 1
  },
  listUserKidName: {
    marginTop: 20
  },
  greenText: {
    color: '#3eab80'
  },
  redText: {
    color: '#fa4e5d'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getIdentities, editIdentityUserKidStatus },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openApprovalProgress', 'updateOpenApprovalProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isApprovalSuccess', 'updateIsApprovalSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('poorStatus', 'setPoorStatus', 'REVIEW'),
  withState('approvalUserKidArrResult', 'setApprovalUserKidArrResult', []),
  withState('approvalResultStr', 'setApprovalResultStr', '審査OK'),
  withState('editParam', 'setEditParam', {
    userId: null,
    newPoorStatus: null,
    reasonComment: null,
    userKidList: []
  }),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      console.log('detail', this.props.detail);
      const getListUserKidUpdate = data => {
        const newData = [];
        data.forEach(element => {
          newData.push({
            userKidId: element.userKidId,
            status: element.status,
            bornEarlyFlag: element.bornEarlyFlag,
            reasonComment: element.reasonComment
          });
        });
        return newData;
      };
      const param = {
        userId: this.props.detail.userId || null,
        newPoorStatus: this.props.detail.poorStatus || null,
        reasonComment: this.props.detail.reasonComment || null,
        userKidList:
          this.props.detail.userKids && this.props.detail.userKids.length > 0
            ? getListUserKidUpdate(this.props.detail.userKids)
            : []
      };
      this.props.setEditParam(param);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    detail,
    checkSession,
    updateOpenApprovalModal,
    openApprovalConfirmModal,
    updateOpenApprovalConfirmModal,
    searchKey,
    openApprovalProgress,
    updateOpenApprovalProgress,
    loading,
    updateLoading,
    isApprovalSuccess,
    updateIsApprovalSuccess,
    resultMessage,
    setResultMessage,
    editParam,
    setEditParam,
    handleChangePage
  }) => {
    const changePoorStatus = value => {
      const tmp = JSON.parse(JSON.stringify(editParam));
      tmp.newPoorStatus = value;
      if (value === 'NG' || value === 'RESUBMIT') {
        if (detail.poorStatus === value) {
          tmp.reasonComment = detail.reasonComment;
        } else {
          tmp.reasonComment = '';
        }
      }
      setEditParam(tmp);
    };

    function changeUserKidStatus(value, index) {
      const tmp = JSON.parse(JSON.stringify(editParam));
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < tmp.userKidList.length; i++) {
        if (i === parseInt(index, 10)) {
          tmp.userKidList[i].status = value;
          if (value === 'NG' || value === 'RESUBMIT') {
            if (detail.userKids[index].status === value) {
              tmp.userKidList[i].reasonComment =
                detail.userKids[index].reasonComment;
            } else {
              tmp.userKidList[i].reasonComment = '';
            }
          }
          break;
        }
      }
      setEditParam(tmp);
    }

    function changeBornEarlyFlag(value, index) {
      const tmp = JSON.parse(JSON.stringify(editParam));
      for (let i = 0; i < tmp.userKidList.length; i += 1) {
        if (i === parseInt(index, 10)) {
          tmp.userKidList[i].bornEarlyFlag = value;
        }
      }
      setEditParam(tmp);
    }

    const handleChangeReasonComment = value => {
      const tmp = JSON.parse(JSON.stringify(editParam));
      tmp.reasonComment = value;
      setEditParam(tmp);
    };

    const handleChangeReasonCommentUserKid = (value, index) => {
      const tmp = JSON.parse(JSON.stringify(editParam));
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < tmp.userKidList.length; i++) {
        if (i === parseInt(index, 10)) {
          tmp.userKidList[i].reasonComment = value;
          break;
        }
      }
      setEditParam(tmp);
    };

    const cancelAction = () => {
      updateOpenApprovalModal(false);
      updateLoading(false);
      updateOpenApprovalProgress(false);
    };
    const confirmAction = () => {
      updateOpenApprovalConfirmModal(true);
    };

    const backAction = () => {
      updateOpenApprovalConfirmModal(false);
      updateLoading(false);
      updateOpenApprovalProgress(false);
    };
    const editAction = async () => {
      updateLoading(true);
      updateOpenApprovalProgress(true);
      const tmp = JSON.parse(JSON.stringify(editParam));
      if (tmp.newPoorStatus === 'OK' || tmp.newPoorStatus === 'REVIEW') {
        tmp.reasonComment = null;
      }
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < tmp.userKidList.length; i++) {
        if (
          tmp.userKidList[i].status === 'OK' ||
          tmp.userKidList[i].status === 'REVIEW'
        ) {
          tmp.userKidList[i].reasonComment = null;
        }
      }
      const editedStatus = await actions
        .editIdentityUserKidStatus(tmp)
        .then(data => checkSession(data));
      if (editedStatus.type === 'EDIT_IDENTITY_USER_KID_STATUS_SUCCESS') {
        updateIsApprovalSuccess(true);
        setResultMessage('更新が完了しました。');
        updateLoading(false);
      } else {
        updateIsApprovalSuccess(false);
        setResultMessage('更新に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isApprovalSuccess) {
        handleChangePage(searchKey);
        updateOpenApprovalConfirmModal(false);
        updateOpenApprovalModal(false);
        updateOpenApprovalProgress(false);
      } else {
        handleChangePage(searchKey);
        updateOpenApprovalProgress(false);
        updateLoading(false);
      }
    };

    const getYearOld = data => {
      const now = new Date();
      const birthday = new Date(data);
      const y1 = now.getFullYear();
      const y2 = birthday.getFullYear();
      return y1 - y2;
    };

    function convertToJapanYear(data) {
      const eras = [
        { name: '令和', start: new Date(2019, 4, 1) }, // May 1, 2019
        { name: '平成', start: new Date(1989, 0, 8) }, // January 8, 1989
        { name: '昭和', start: new Date(1926, 11, 25) }, // December 25, 1926
        { name: '大正', start: new Date(1912, 6, 30) }, // July 30, 1912
        { name: '明治', start: new Date(1868, 0, 25) } // January 25, 1868
      ];

      const date = new Date(data);
      for (let i = 0; i < eras.length; i += 1) {
        const era = eras[i];
        if (date >= era.start) {
          const eraYear = date.getFullYear() - era.start.getFullYear() + 1;
          return `${era.name}${eraYear}年`;
        }
      }

      // If the year is before the Meiji era
      return `西暦${date.getFullYear()}年`;
    }

    console.log('editParam', editParam);

    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.titleHeader}>
          こどもごちめし対象者書類審査
        </Typography>
        <div className={classes.textUserName}>
          <Typography variant="p" color="textPrimary" className={classes.fs20}>
            {`${detail.displayName}様`}
          </Typography>
        </div>
        <div className={classes.listUserKidName}>
          {detail &&
            detail.userKids &&
            detail.userKids.length &&
            detail.userKids.map((item, index) => {
              return (
                <Typography
                  color="textPrimary"
                  className={classes.fs18}
                  key={`user-kid-name-${item.userKidId}`}
                >
                  {`※お子様${index + 1}人目：${item.displayName}`}
                </Typography>
              );
            })}
        </div>
        <div className={classNames(classes.mt40, classes.itemDiv)}>
          <Typography variant="p" color="textPrimary" className={classes.fs20}>
            ①困窮者登録証明書
          </Typography>
        </div>
        {detail.poorStatus && detail.poorStatus !== 'INIT' ? (
          <div
            className={classNames(classes.itemDiv, classes.kidInfoContainer)}
          >
            <div className={classes.kidInfoDetails}>
              <React.Fragment>
                <div className={classes.mb52}>
                  <RadioGroup
                    value={editParam.newPoorStatus}
                    onChange={e => {
                      changePoorStatus(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="OK"
                      control={<Radio color="primary" />}
                      label="審査OK"
                      disabled={detail.poorStatus === 'OK'}
                      className={classes.fs16}
                    />
                    <FormControlLabel
                      value="REVIEW"
                      control={<Radio color="primary" />}
                      label="審査中"
                      disabled={detail.poorStatus === 'OK'}
                      className={classes.fs16}
                    />
                    <FormControlLabel
                      value="NG"
                      control={<Radio color="primary" />}
                      label="審査NG"
                      disabled={detail.poorStatus === 'OK'}
                      className={classes.fs16}
                    />
                    <FormControlLabel
                      value="RESUBMIT"
                      control={<Radio color="primary" />}
                      label="再提出依頼中"
                      disabled={detail.poorStatus === 'OK'}
                      className={classes.fs16}
                    />
                  </RadioGroup>
                  {(editParam.newPoorStatus === 'NG' ||
                    editParam.newPoorStatus === 'RESUBMIT') && (
                    <div>
                      <div>理由</div>
                      <textarea
                        label="理由"
                        fullWidth
                        multiline
                        value={editParam.reasonComment}
                        margin="normal"
                        className={classes.reasonComment}
                        onChange={e => {
                          handleChangeReasonComment(e.target.value);
                        }}
                      />
                    </div>
                  )}
                </div>
              </React.Fragment>
            </div>
            <div className={classes.kidInfoImage}>
              {detail.listPoorUserImage.map(item => {
                return (
                  <a
                    href={item.imagePresigned}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card className={classes.itemDiv}>
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          image={item.imagePresigned}
                          style={styles.imageIdentity}
                        />
                      </CardActionArea>
                    </Card>
                  </a>
                );
              })}
            </div>
          </div>
        ) : (
          <div className={classes.itemDiv}>
            <Typography variant="p" color="textPrimary">
              登録しない
            </Typography>
          </div>
        )}
        <Divider />
        <div className={classNames(classes.mt40, classes.itemDiv)}>
          <Typography variant="p" color="textPrimary" className={classes.fs20}>
            ②お子様情報と証明書
          </Typography>
        </div>
        {detail &&
          detail.userKids &&
          detail.userKids.length &&
          detail.userKids.map((item, index) => {
            const tempItem =
              editParam &&
              editParam.userKidList &&
              editParam.userKidList[index];
            return (
              <div
                key={`approve-${item.userKidId}`}
                className={classes.kidInfoContainer}
              >
                <div className={classes.kidInfoDetails}>
                  <div className={classNames(classes.itemDiv, classes.fs18)}>
                    <div>
                      <span>※お子様</span>
                      <span className={classes.textRed}>{index + 1}</span>
                      <span>人目</span>
                    </div>

                    <div>
                      {`OCR証明書判定：${
                        item.documentTitleOcr ? item.documentTitleOcr : ''
                      }`}
                    </div>
                  </div>
                  {(item.status === 'REVIEW' || item.status === 'RESUBMIT') && (
                    <div className={classNames(classes.itemDiv, classes.fs18)}>
                      <div>{`氏名：${item.displayName}`}</div>
                      <div
                        className={
                          item.displayName
                            .replace(/[\u0020\u3000]+/g, '')
                            .trim() !==
                          (item.displayNameOcr &&
                            item.displayNameOcr
                              .replace(/[\u0020\u3000]+/g, '')
                              .trim())
                            ? classes.redText
                            : ''
                        }
                      >
                        <span>
                          {`OCR：${
                            item.displayNameOcr ? item.displayNameOcr : ''
                          }`}
                        </span>
                        <span>(</span>
                        <span
                          className={
                            item.displayName
                              .replace(/[\u0020\u3000]+/g, '')
                              .trim() ===
                            (item.displayNameOcr &&
                              item.displayNameOcr
                                .replace(/[\u0020\u3000]+/g, '')
                                .trim())
                              ? classes.greenText
                              : ''
                          }
                        >
                          {item.displayName
                            .replace(/[\u0020\u3000]+/g, '')
                            .trim() ===
                          (item.displayNameOcr &&
                            item.displayNameOcr
                              .replace(/[\u0020\u3000]+/g, '')
                              .trim())
                            ? 'OK'
                            : 'NG'}
                        </span>
                        <span>)</span>
                      </div>
                    </div>
                  )}
                  <div className={classNames(classes.itemDiv, classes.fs18)}>
                    {`ニックネーム：${
                      // eslint-disable-next-line no-nested-ternary
                      item.status === 'OK'
                        ? item.displayName
                        : item.nickName !== null
                        ? item.nickName
                        : ''
                    }`}
                  </div>
                  <div className={classNames(classes.itemDiv, classes.fs18)}>
                    <div>
                      {item.birthdayNewFlag === 0
                        ? `生年月：${convertToJapanYear(item.birthday)}${moment(
                            item.birthday
                          ).format('MM月')}（${moment(item.birthday).format(
                            'YYYY/MM'
                          )}）・`
                        : `生年月日：${convertToJapanYear(
                            item.birthday
                          )}${moment(item.birthday).format(
                            'MM月DD日'
                          )}（${moment(item.birthday).format(
                            'YYYY/MM/DD'
                          )}）・`}
                      {`${getYearOld(item.birthday)}歳`}
                    </div>
                    {(item.status === 'REVIEW' ||
                      item.status === 'RESUBMIT') && (
                      <div
                        className={
                          (item.birthdayNewFlag === 0 &&
                            moment(item.birthday).format('YYYY/MM') !==
                              moment(item.birthdayOcr).format('YYYY/MM')) ||
                          (item.birthdayNewFlag === 1 &&
                            moment(item.birthday).format('YYYY/MM/DD') !==
                              moment(item.birthdayOcr).format('YYYY/MM/DD'))
                            ? classes.redText
                            : ''
                        }
                      >
                        <span>OCR：</span>
                        {item.birthdayOcr && (
                          <span>
                            {`${convertToJapanYear(item.birthdayOcr)}${moment(
                              item.birthdayOcr
                            ).format('MM月DD日')}（${moment(
                              item.birthdayOcr
                            ).format('YYYY/MM/DD')}）・${getYearOld(
                              item.birthdayOcr
                            )}歳`}
                          </span>
                        )}
                        <span>(</span>
                        <span
                          className={
                            (item.birthdayNewFlag === 0 &&
                              moment(item.birthday).format('YYYY/MM') ===
                                moment(item.birthdayOcr).format('YYYY/MM')) ||
                            (item.birthdayNewFlag === 1 &&
                              moment(item.birthday).format('YYYY/MM/DD') ===
                                moment(item.birthdayOcr).format('YYYY/MM/DD'))
                              ? classes.greenText
                              : ''
                          }
                        >
                          {item.birthdayOcr &&
                          ((item.birthdayNewFlag === 0 &&
                            moment(item.birthday).format('YYYY/MM') ===
                              moment(item.birthdayOcr).format('YYYY/MM')) ||
                            (item.birthdayNewFlag === 1 &&
                              moment(item.birthday).format('YYYY/MM/DD') ===
                                moment(item.birthdayOcr).format('YYYY/MM/DD')))
                            ? 'OK'
                            : 'NG'}
                        </span>
                        <span>)</span>
                      </div>
                    )}
                  </div>
                  <div className={classNames(classes.itemDiv, classes.fs18)}>
                    <div>
                      {`住所：${item.prefectures ? item.prefectures : ''} ${
                        item.city ? item.city : ''
                      }`}
                    </div>
                    {(item.status === 'REVIEW' ||
                      item.status === 'RESUBMIT') && (
                      <div
                        className={
                          item.prefectures !== item.prefecturesOcr ||
                          item.city !== item.cityOcr
                            ? classes.redText
                            : ''
                        }
                      >
                        <span>
                          {`OCR：${
                            item.prefecturesOcr ? item.prefecturesOcr : ''
                          } ${item.cityOcr ? item.cityOcr : ''}`}
                        </span>
                        <span>(</span>
                        <span
                          className={
                            item.prefectures === item.prefecturesOcr &&
                            item.city === item.cityOcr
                              ? classes.greenText
                              : ''
                          }
                        >
                          {item.prefectures === item.prefecturesOcr &&
                          item.city === item.cityOcr
                            ? 'OK'
                            : 'NG'}
                        </span>
                        <span>)</span>
                      </div>
                    )}
                  </div>
                  {(item.status === 'REVIEW' || item.status === 'RESUBMIT') && (
                    <div>
                      <div className={classes.fs18}>OCR結果：</div>
                      {item.ocrResponse !== null && (
                        <textarea
                          label="OCR結果："
                          fullWidth
                          multiline
                          value={item.ocrResponse}
                          margin="normal"
                          className={classes.reasonComment}
                          disabled
                        />
                      )}
                    </div>
                  )}
                  <div className={classes.mb52}>
                    <React.Fragment>
                      <div>
                        <FormControlLabel
                          label="早生まれ"
                          control={
                            <Checkbox
                              color="primary"
                              checked={
                                !!(
                                  editParam &&
                                  editParam.userKidList &&
                                  editParam.userKidList[index] &&
                                  editParam.userKidList[index].bornEarlyFlag ===
                                    1
                                )
                              }
                              onChange={e => {
                                changeBornEarlyFlag(
                                  e.target.checked ? 1 : 0,
                                  index
                                );
                              }}
                              disabled={item.status === 'OK'}
                            />
                          }
                        />
                      </div>
                      <div className={classNames(classes.itemDiv)}>
                        <RadioGroup
                          row
                          value={
                            editParam &&
                            editParam.userKidList &&
                            editParam.userKidList[index] &&
                            editParam.userKidList[index].status
                              ? editParam.userKidList[index].status
                              : 'REVIEW'
                          }
                          onChange={e => {
                            changeUserKidStatus(e.target.value, index);
                          }}
                        >
                          <FormControlLabel
                            value="OK"
                            control={<Radio color="primary" />}
                            label="審査OK"
                            disabled={item.status === 'OK'}
                            className={classes.fs16}
                          />
                          <FormControlLabel
                            value="REVIEW"
                            control={<Radio color="primary" />}
                            label="審査中"
                            disabled={item.status === 'OK'}
                            className={classes.fs16}
                          />
                          <FormControlLabel
                            value="NG"
                            control={<Radio color="primary" />}
                            label="審査NG"
                            disabled={item.status === 'OK'}
                            className={classes.fs16}
                          />
                          <FormControlLabel
                            value="RESUBMIT"
                            control={<Radio color="primary" />}
                            label="再提出依頼中"
                            disabled={item.status === 'OK'}
                            className={classes.fs16}
                          />
                        </RadioGroup>
                      </div>
                      {tempItem &&
                        (tempItem.status === 'NG' ||
                          tempItem.status === 'RESUBMIT') && (
                          <div>
                            <div>理由</div>
                            <textarea
                              label="理由"
                              fullWidth
                              multiline
                              value={tempItem && tempItem.reasonComment}
                              margin="normal"
                              className={classes.reasonComment}
                              onChange={e => {
                                handleChangeReasonCommentUserKid(
                                  e.target.value,
                                  index
                                );
                              }}
                            />
                          </div>
                        )}
                    </React.Fragment>
                  </div>
                </div>
                <div className={classes.kidInfoImage}>
                  {item.listUserKidImagePresigned &&
                    item.listUserKidImagePresigned.length &&
                    item.listUserKidImagePresigned.map((image, indexImage) => {
                      return (
                        <a
                          // eslint-disable-next-line react/no-array-index-key
                          key={`iamge-user-kid-${item.userKidId}-${indexImage}`}
                          href={image}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Card className={classes.itemDiv}>
                            <CardActionArea>
                              <CardMedia
                                component="img"
                                image={image}
                                style={styles.imageIdentity}
                              />
                            </CardActionArea>
                          </Card>
                        </a>
                      );
                    })}
                </div>
              </div>
            );
          })}
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openApprovalConfirmModal}>
          <IdentityUserKidApprovalConfirm
            backAction={backAction}
            editAction={editAction}
            editConfirm={editParam}
            openApprovalProgress={openApprovalProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            detail={detail}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
